import { useEffect, useState } from 'react';

// How long a copy button of an answer shows its check.
const COPIED_MS = 1600;

/** Whether the button shows its check, and the call that shows it, for a moment, after a copy. */
export function useCopied(): [boolean, () => void] {
    const [copied, setCopied] = useState(false);
    useEffect(() => {
        if (!copied) {
            return undefined;
        }
        const timer = setTimeout(() => setCopied(false), COPIED_MS);
        return () => clearTimeout(timer);
    }, [copied]);
    return [copied, () => setCopied(true)];
}
